import { STATUS } from "@/constant/statusConstants";
import { BOOLEAN_OPTIONS } from "@/constant/GeneralOptions/boolean";

const PlayerInitialValues = (showData = null) => {
  const data = showData?.data;
  return {
    code: data?.code || "",
    sport_id: data?.sport_id || "",
    player_type_id: data?.player_type_id || "",
    name: data?.name || "",
    birth_city: data?.birth_city || "",
    birth_country_id: data?.birth_country_id || "",
    birth_date: data?.birth_date || "",
    height: data?.height || "",
    nationality_id_1: data?.nationality_id_1 || "",
    nationality_id_2: data?.nationality_id_2 || "",
    nationality_id_3: data?.nationality_id_3 || "",
    is_notable_player: data?.is_notable_player || BOOLEAN_OPTIONS.NO,
    is_legend_player: data?.is_legend_player || BOOLEAN_OPTIONS.NO,
    show_in_profile: data?.show_in_profile || BOOLEAN_OPTIONS.NO,
    tags: data?.tags || [],
    banner_file_url: data?.banner_file_url || "",
    thumbnail_file_url: data?.thumbnail_file_url || "",
    status: data?.status || STATUS.INACTIVE,
    history_status: data?.history_status || STATUS.INACTIVE,
    auto_translate: data?.auto_translate ?? BOOLEAN_OPTIONS.NO,
    tagline: data?.tagline || "",
    content: data?.content || "",
  };
};

export default PlayerInitialValues;
